import { React, useState } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {
  Grid,
  Box,
  Paper,
  useMediaQuery
} from '@material-ui/core';
import { ROUTES } from '../../../../constants/routes';
import { useHistory } from 'react-router-dom'
import { motion } from "framer-motion/dist/es/index";

export default function SectionOne(props) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.up('md'));
  const isMobileSmall = useMediaQuery(theme.breakpoints.up('md'));
  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      fontFamily: 'Raleway',
    },
    sectionOne: {
      backgroundColor: 'white',
      paddingLeft: 20,
      paddingRight: 20,
      fontSize: '1.2rem',
      color: 'black',
      marginTop: '80px'

    },
    sectionOneMobile: {
      backgroundColor: 'white',
      fontSize: '.9rem',
      color: 'black',
      marginTop: '80px'

    },
    innerGridContainer: {
      width: "100%",
      margin: "0px",
      padding: "30px"
    },
    innerGridSmallHeading: {
      width: "100%",
      textAlign: "left",
      fontSize: "1rem",
      fontWeight: "bold"
    },
    innerGridHeading: {
      width: "100%",
      textAlign: "left",
      fontSize: "3rem",
      fontFamily: "sans-serif"
    },
    sectionParagraph: {
      // margin: "10px 0px",
      textAlign: "left",
      fontSize: ".6rem",
      marginTop: '-30px',
      fontWeight: 'bold'
    },
    media: {
      maxHeight: 300,
      maxWidth: 700,
      minHeight: 300,
      float: 'right',
      width: '100%'
    },
    
  }));

  const classes = useStyles();
  const history = useHistory();
  const text1 = 'Get in tune.'
  const text2 = 'Get in touch'
  const sentence = {
    hidden: { opacity: 1 },
    visible: {
      opacity: 1,
      transition: {
        delay: 1,
        staggerChildren: 0.2,
      },
    },
  }

  const letter = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
    }
  }

  return (
    <div className={classes.root}>
      <section className={isMobile ? classes.sectionOne : classes.sectionOneMobile}>
        <Grid container>
          <Grid item xs={2}></Grid>
          <Grid item xs={5} className={classes.innerGridContainer} container spacing={2}>
            {/* <h5 className={classes.innerGridSmallHeading}>Lorem ipsum dolor</h5> */}
            <h5 className={classes.innerGridHeading}>
              {/* We Make */}
              <motion.h3 className='load-screen--message'
                variants={sentence}
                initial='hidden'
                animate='visible'
                style={{ fontSize: '3.5rem' }}
              >
                <Grid container>
                  <p style={{ fontWeight: "200", textAlign: 'left' }}>
                    {
                      text1.split("").map((char, index) => {
                        return (
                          <motion.span key={char + "-" + index} variants={letter}>
                            {char}
                          </motion.span>
                        )
                      })
                    }
                  </p>
                </Grid>
                <Grid container>
                  <p style={{ fontWeight: "bold", textAlign: 'left' }}>
                    {
                      text2.split("").map((char, index) => {
                        return (
                          <motion.span key={char + "-" + index} variants={letter}>
                            {char}
                          </motion.span>
                        )
                      })
                    }
                  </p>
                  
                </Grid>
              </motion.h3>
            </h5>
            <Grid container direction="row" justify="left" alignItems="left">
              <p className={classes.sectionParagraph}>
                Kontakt os, og hor mere om design for sanserne
              </p>
            </Grid>
          </Grid>
        </Grid>
      </section >
    </div >
  )
}